import React from 'react'
import { css } from '@linaria/core'
import { useTranslation } from 'react-i18next'
import { colors, Button } from '@fs/zion-ui'
import { Elevation } from '@fs/zion-ui/quarks-authorized-use-only'

const skipTabCss = css`
  top: -500px;
  background: ${colors.gray00};
  border-radius: 4px;
  position: absolute !important; /* to beat the postition relative rule in Elevation */
  /* This is the ONLY option to guarantee it stays above the header,
   * since it is above the header in dom order. Nothing else should
   * ever use anything than z-index of 1. */
  z-index: 3;
  max-width: 80%;
  &:focus-within {
    top: 76px;
    inset-inline-start: 20px;
  }
`

const skipTabInnerCss = css`
  /* Needed so low emphasis button won't bleed off the sides */
  margin: 0 8px;
  height: 40px;
`

export default ({ id }) => {
  const [t] = useTranslation()
  return (
    <Elevation z={4} className={skipTabCss}>
      <div className={skipTabInnerCss}>
        <Button external to={`#${id}`} linkName="Root: Skip to Main Content">
          {t('skip.to.content', 'Skip to Main Content')}
        </Button>
      </div>
    </Elevation>
  )
}
